import { getConciliationAccountDisplayNumber } from '../../../../../../utils/conciliationAccountDisplay'
// import { getBankAssignedAmount } from '../../../../../../utils/vinculacionAmounts'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { formatCurrency, formatDate } from '../../../../../../utils/formatter'
import { Text } from '../../../../../ui'
import clsx from 'clsx'
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import { bankIcons } from '../../../../../views/dashboard/Administracion/bancos/data'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { useEffect, useRef } from 'react'

const TableConciliar = ({rows,
  rowsdataModal,
  setInitialSelectedIds,
  onCurrentData,
  onCheckboxChange,
  dataLinkage, 
  dataLinkagePre,
  tipoLibro,
  onSort,
  order,
  dataModal,
  reconciliationDetail,
  selectedIds,
  setSelectedIds,
  unselectedIds,
  setUnselectedIds,
  selectedCheckboxes,
  setSelectedCheckboxes
}) => {
  const initializedSelectionKeyRef = useRef(null)
  const serverLinkage = tipoLibro === 'previred'
    ? dataModal?.linkagePrevired
    : dataModal?.linkage
  const serverLinkageRows = Array.isArray(serverLinkage) ? serverLinkage : []
  const getServerLinkedRow = item => {
    const comprobante = String(item?.comprobante ?? '').trim()
    const rowIds = [item?.id, item?.idPrincipal].filter(id => id != null).map(String)
    return serverLinkageRows.find(linkedItem => {
      const linkedComprobante = String(linkedItem?.comprobante ?? '').trim()
      const linkedIds = [linkedItem?.id, linkedItem?.idPrincipal]
        .filter(id => id != null)
        .map(String)
      return (
        (comprobante && comprobante === linkedComprobante) ||
        rowIds.some(id => linkedIds.includes(id))
      )
    })
  }
  const isServerLinkedRow = item => Boolean(getServerLinkedRow(item))
  const getMovementDate = item => {
    const linked = getServerLinkedRow(item)
    return linked ? linked.fechaRelacionada : item.fecha
  }
  const isExplicitlyUnselected = (item, idsDesmarcados = unselectedIds) => {
    const comprobante = String(item?.comprobante ?? '').trim()
    const ids = new Set(
      [item?.id, item?.idPrincipal].filter(id => id != null).map(String)
    )

    serverLinkageRows.forEach(linkedItem => {
      const linkedComprobante = String(linkedItem?.comprobante ?? '').trim()
      const linkedIds = [linkedItem?.id, linkedItem?.idPrincipal]
        .filter(id => id != null)
        .map(String)
      const sharesId = linkedIds.some(id => ids.has(id))
      if ((comprobante && comprobante === linkedComprobante) || sharesId) {
        linkedIds.forEach(id => ids.add(id))
      }
    })

    return (idsDesmarcados || []).some(id => ids.has(String(id)))
  }
  const isRowChecked = item =>
    !isExplicitlyUnselected(item) &&
    (selectedCheckboxes[item.id] === true || isServerLinkedRow(item))

  const handleCheckboxToggle = item => {
    const id = item.id
    const unselectedId = item.idPrincipal ?? id
    const wasChecked = isRowChecked(item)
    const updatedSelection = {
      ...selectedCheckboxes,
      [id]: !wasChecked
    }
    const nextUnselectedIds = wasChecked
      ? [...new Set([...(unselectedIds || []), unselectedId])]
      : (unselectedIds || []).filter(
          value => String(value) !== String(id) && String(value) !== String(unselectedId)
        )

    // La selección efectiva incluye tanto las filas nuevas como las que ya
    // estaban vinculadas en el servidor y no fueron desmarcadas.
    const selectedData = rows.filter(row => {
      if (isExplicitlyUnselected(row, nextUnselectedIds)) return false
      return updatedSelection[row.id] === true || isServerLinkedRow(row)
    })
    const newSelectedIds = selectedData
      .map(row => row.id)
      .filter(rowId => rowId != null)

    setSelectedCheckboxes(updatedSelection)
    setSelectedIds(newSelectedIds)
    setUnselectedIds(nextUnselectedIds)
    onCurrentData(selectedData)
  }

  const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-medium',
  }
  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'cuentaCorriente' },
    { col: 'Descripción', field: 'descripcion' },
    { col: 'Cargo', field: 'cargo' },
    { col: 'Disponible', field: null },
    //{ col: 'Status', field: 'status' },
    {col: 'Acciones', field: null}
  ]

  const normalizeRemuneracionStatus = status =>
    String(status || '')
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s*UNDEFINED\s*/g, ' ')
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()

  const getRemuneracionStatusKey = status => {
    const normalized = normalizeRemuneracionStatus(status)
    if (!normalized) return 'OTHER'
    if (normalized.includes('PARCIALMENTE PAGADO')) return 'PARCIALMENTE_PAGADO'
    if (normalized.includes('POR PAG')) return 'POR_PAGAR'
    if (normalized.includes('PAGADO')) return 'PAGADO'
    return 'OTHER'
  }

 useEffect(() => {
  if (!Array.isArray(rows) || rows.length === 0) return

  const newSelection = {}

  const statusModal = tipoLibro === 'liquido'
    ? dataModal?.status
    : dataModal?.statusPrevired
  const statusModalKey = getRemuneracionStatusKey(statusModal)

  const linkageData = tipoLibro === 'liquido'
    ? dataModal?.linkage
    : dataModal?.linkagePrevired

  const currentDataLinkage = tipoLibro === 'liquido'
    ? dataLinkage
    : dataLinkagePre

  const e2eLinkageIds = (
    Array.isArray(currentDataLinkage) ? currentDataLinkage : []
  )
    .filter(item => item?.__e2eRemuneracion === true)
    .map(item => item?.idPrincipal ?? item?.id)
    .filter(id => id != null)
    .map(String)

  const linkageComprobantes = Array.isArray(linkageData)
    ? linkageData.map(item => String(item.comprobante ?? '').trim()).filter(Boolean)
    : []
  const selectionKey = JSON.stringify({
    tipoLibro,
    id: dataModal?.id ?? dataModal?.idLiquido ?? dataModal?.idPrevired,
    linkageComprobantes,
    e2eLinkageIds
  })

  if (initializedSelectionKeyRef.current === selectionKey) return

  rows.forEach((item) => {
    const isSameLinkage = linkageComprobantes.includes(String(item.comprobante ?? '').trim())

    const itemId = item?.idPrincipal ?? item?.id
    const isE2eLinkage =
      itemId != null &&
      e2eLinkageIds.includes(String(itemId))

    const shouldBeSelected = (() => {
      if (isE2eLinkage) {
        return true
      }

      if (statusModalKey === 'PAGADO') {
        return isSameLinkage
      }

      if (statusModalKey === 'PARCIALMENTE_PAGADO') {
        return linkageComprobantes.includes(item.comprobante)
      }

      return false
    })()

    if (shouldBeSelected) {
      newSelection[item.id] = true
    }
  })

  setSelectedCheckboxes(newSelection)

  const selectedIds = Object.keys(newSelection).map(Number)
  const selectedData = rows.filter(row => selectedIds.includes(row.id))
  onCheckboxChange(selectedIds)
  onCurrentData(selectedData)
  initializedSelectionKeyRef.current = selectionKey
}, [rows, tipoLibro, dataModal, dataLinkage, dataLinkagePre])

// const getCleanStatus = row =>
//       typeof row?.status === 'string'
//         ? row.status.replace(/\s*undefined\s*/gi, '').trim()
//         : ''
//
//   const normalizeStatus = status =>
//       String(status || '')
//         .replace(/\s*undefined\s*/gi, '')
//         .trim()
//         .toUpperCase()
//
//   const getDisplayStatus = (rowStatus, isChecked) => {
//     const normalizedRowStatus = normalizeStatus(rowStatus)
//
//     // Si el movimiento pertenece a esta conciliación,
//     // su estado dentro del modal es CONCILIADO.
//     if (isChecked) {
//       return 'CONCILIADO'
//     }
//
//     // Si no pertenece a esta conciliación,
//     // conserva el estado nativo de Luca.
//     if (normalizedRowStatus && normalizedRowStatus !== '-') {
//       return normalizedRowStatus
//     }
//
//     return 'PENDIENTE'
//   }
//
//   // const getDisplayStatus = (rowStatus, isChecked) => {
//   //   const normalizedRowStatus = normalizeStatus(rowStatus)
//
//   //   // Dentro del modal manda el estado contextual de la conciliación.
//   //   if (isChecked) {
//   //     const parentStatus = normalizeStatus(
//   //       reconciliationDetail?.status ||
//   //       (tipoLibro === 'liquido' ? dataModal?.status : dataModal?.statusPrevired)
//   //     )
//
//   //     if (parentStatus.includes('PARCIALMENTE COBRADO')) return 'PARCIALMENTE COBRADO'
//   //     if (parentStatus.includes('PARCIALMENTE PAGADO')) return 'PARCIALMENTE PAGADO'
//   //     if (parentStatus.includes('PARCIALMENTE CONCILIADO')) return 'PARCIALMENTE CONCILIADO'
//   //     if (parentStatus.includes('COBRADO')) return 'COBRADO'
//   //     if (parentStatus.includes('PAGADO')) return 'PAGADO'
//   //     if (parentStatus.includes('CONCILIADO')) return 'CONCILIADO'
//   //   }
//
//   //   // Si no pertenece a esta conciliación, conserva el estado nativo de Luca.
//   //   if (normalizedRowStatus && normalizedRowStatus !== '-') {
//   //     return normalizedRowStatus
//   //   }
//
//   //   return ''
//   // }
//
//     const statusTone = status => {
//       const s = normalizeStatus(status)
//       if (s.includes('PARCIAL')) return 'warning'
//       if (s.includes('CONCILIADO') || s.includes('PAGADO') || s.includes('COBRADO')) return 'success'
//       if (s.includes('PENDIENTE')) return 'danger'
//       if (s.includes('PARCIAL') && s.includes('ANUL')) return 'muted'
//       return 'muted'
//     }
//
//     const statusBadgeClass = status => {
//       const tone = statusTone(status)
//       return clsx(
//         'inline-flex items-center justify-center px-3 py-1 rounded-full text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider',
//         {
//           'text-danger bg-danger/10': tone === 'danger',
//           'text-success bg-success/10': tone === 'success',
//           'text-amber-700 bg-amber-100': tone === 'warning',
//           'text-muted bg-border/40': tone === 'muted'
//         }
//       )
//     }
//
  const truncateText = (text, max = 15) => {
    if (!text) return ''
    return text.length > max ? text.slice(0, max) + '...' : text
  }

  return (
     <div className={styles.wrapper}>
        <div className='mt-2'>
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                {orderableCols.map(({ col, field }, i) => (
                  <th
                    className={clsx(
                      styles.th,
                      { 'cursor-pointer': field },
                      i === 0 && styles.mediumCol
                    )}
                    onClick={() => field && onSort({ col, field })}
                    key={i}
                  >
                    {col}
                    {order.col === col && (
                      <KeyboardArrowDownIcon
                        className={clsx('transition-all ml-2 cursor-pointer', {
                          'opacity-40': order.col !== col,
                          'rotate-180': order.direction === 'desc'
                        })}
                      />
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className={styles.tbody}>
              {rows.map((item, i) => {
                const isChecked = isRowChecked(item)
//                 const assignedAmount = getBankAssignedAmount(item, serverLinkageRows, dataModal, isChecked)
//                 const cleanStatus = getCleanStatus(item)
//                 const displayStatus = getDisplayStatus(cleanStatus, isChecked)
                return(
              <tr key={item.id} className={clsx(styles.tr)}>
                {/* Nombre origen */}
                <td className={clsx(styles.td, styles.smallCol, 'text-center')}>
                  <div className="flex items-center justify-center gap-1">
                    <input type="checkbox" className="rounded" checked={isChecked} onChange={() => handleCheckboxToggle(item)}/>
                    <img src={bankIcons[item.nombreCuentaBanco] || imgDefaultBank} className="h-6 w-auto rounded" />
                  </div>
                </td>
                {/* Fecha */}
                <td className={clsx(styles.td, styles.smallCol)}>
                  <Text className={styles.boldText}>{formatDate(getMovementDate(item))}</Text>
                </td>
                {/* Cuenta */}
                <td className={clsx(styles.td, styles.wideCol)}>
                  <Text className={styles.boldText}>{item.nombreCuentaBanco}</Text>
                  <Text className={styles.text}>{getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco)}</Text>
                </td>
                {/* Fecha */}
                <td className={clsx(styles.td, styles.wideCol)}>
                  <Text className={clsx(styles.boldText, 'truncate')}  title={item.descripcion}>{truncateText(item.descripcion)}</Text>
                </td>
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <Text className={styles.boldText}>{formatCurrency(item.montoTotal ?? item.montoCargo)}</Text>
                </td>
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <Text className={styles.boldText}>{formatCurrency(item.auxiliar)}</Text>
                </td>
                {/*<td className={clsx(styles.td, styles.mediumCol)}>
                  <span className={statusBadgeClass(displayStatus)}>
                    {displayStatus || '—'}
                  </span>
                </td>*/}
                {/* Acciones */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <div className='flex h-full items-center justify-center space-x-3'>
                    <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
                      <button
                        className={clsx(
                          'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                          {
                            'bg-accent2 text-white hover:bg-accent2/90 cursor-pointer': isChecked,
                            'bg-gray-100 text-gray-300 hover:bg-gray-200 cursor-pointer': !isChecked,
                          }
                        )}
                        onClick={() => handleCheckboxToggle(item)}
                      >
                        <DoneAllIcon className="w-4 h-4" />
                      </button>
                      <Text className='mt-2'>
                        {isChecked ? 'Seleccionado' : 'Seleccionar'}
                      </Text>
                    </div>
                  </div>
                </td>
              </tr>
              )
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default TableConciliar
